import React, { useState } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { Container, Row, Col, Modal, ModalBody } from 'reactstrap'

import { ArticlesTitle } from './articles'
import PocketMoneyBenefit from './pocket-money-benefit'

import skyBG from '../../images/parent/sky_bg.svg'
import searchIcon from '../../images/parent/search-icon.svg'
import searchIconGreen from '../../images/search-icon-green.svg'
import closeIcon from '../../images/close_icon.svg'

const CuriosityWrapper = styled.div`
  background-image: url(${skyBG});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  padding-top: 60px;
  padding-bottom: 60px;
  @media (max-width: 575px) {
    background-size: 550%;
  }
`

const CuriosityContainer = styled(Container)``

const CuriosityTitleWrapper = styled(Col)`
  margin-bottom: 15px;
`

export const CuriosityTitle = styled(ArticlesTitle)`
  color: ${(props) => props.theme.colorWhite};
  text-align: left;
  margin-bottom: 40px;
  span {
    &:before {
      right: 28%;
    }
  }
`

const CuriosityDescWrapper = styled(Col)`
  margin-bottom: 30px;

  p {
    font-size: 16px;
    font-weight: 300;
    strong {
      font-size: 24px;
    }
  }
  br {
    @media (max-width: 991px) {
      display: none;
    }
  }
`

const CuriosityCardWrapper = styled(Col)`
  margin-bottom: 20px;
  .curiosityImage {
    @media (max-width: 575px) {
      display: none;
    }
  }
  .curiosityImageMobile {
    display: none;
    @media (max-width: 575px) {
      display: block;
    }
  }
`

const CuriosityLinkWrapper = styled.div`
  text-align: center;
  @media (max-width: 575px) {
    text-align: right;
  }
`

const CuriosityLink = styled.div`
  position: relative;
  display: inline-block;
  background-color: ${(props) => props.theme.colorGreenLight};
  color: ${(props) => props.theme.colorWhite};
  font-family: ${(props) => props.theme.fontBNPPSansCondensed};
  font-size: 24px;
  font-weight: 400;
  text-transform: uppercase;
  padding-left: 50px;
  padding-right: 50px;
  margin-top: 40px;
  transition: all 0.2s ease;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 991px) {
    display: block;
  }
  @media (max-width: 575px) {
    background-color: transparent;
    color: ${(props) => props.theme.colorGreenLight};
    padding-left: 25px;
    padding-right: 25px;
    margin-top: -15px;
    margin-right: 15px;
  }
  &:hover,
  &:focus {
    color: ${(props) => props.theme.colorWhite};
    text-decoration: none;
    @media (max-width: 575px) {
      color: ${(props) => props.theme.colorGreenLight};
    }
    &:before {
      transform: translateY(-50%) scale(1.2);
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    right: 24px;
    width: 16px;
    height: 16px;
    background-image: url(${searchIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform: translateY(-50%) scale(1);
    @media (max-width: 575px) {
      right: 0;
      background-image: url(${searchIconGreen});
    }
  }
`

export const CuriosityModal = styled(Modal)`
  margin-top: 6rem;
  .curiosityImage {
    @media (max-width: 575px) {
      display: none;
    }
  }
  .curiosityImageMobile {
    display: none;
    @media (max-width: 575px) {
      display: block;
    }
  }
`

export const CuriosityCloseButton = styled.div`
  width: 25px;
  height: 25px;
  background-image: url(${closeIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 10px;
  margin-left: auto;
  margin-right: 0;
  margin-bottom: 25px;
  transition: all 0.2s ease;
  cursor: pointer;
  @media (max-width: 575px) {
    margin-top: 5px;
    margin-bottom: 15px;
  }
  &:hover,
  &:focus {
    opacity: 0.65;
  }
`

const Curiosity = (props) => {
  const data = useStaticQuery(graphql`
    query {
      CuriosityImage1: file(
        relativePath: { eq: "parent/curiosity/curiosity4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityImage2: file(
        relativePath: { eq: "parent/curiosity/curiosity1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityImage3: file(
        relativePath: { eq: "parent/curiosity/curiosity2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      CuriosityImageMobile1: file(
        relativePath: { eq: "parent/curiosity/curiosity4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityImageMobile2: file(
        relativePath: { eq: "parent/curiosity/curiosity2_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityImageMobile3: file(
        relativePath: { eq: "parent/curiosity/curiosity1_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      CuriosityBigImage1: file(
        relativePath: { eq: "parent/curiosity/curiosity4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityBigImage2: file(
        relativePath: { eq: "parent/curiosity/DESKTOP/desktop_1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityBigImage3: file(
        relativePath: { eq: "parent/curiosity/DESKTOP/desktop_2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      CuriosityBigImageMobile1: file(
        relativePath: { eq: "parent/curiosity/curiosity4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 720) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityBigImageMobile2: file(
        relativePath: { eq: "parent/curiosity/MOBILE/mobile_2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 720) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CuriosityBigImageMobile3: file(
        relativePath: { eq: "parent/curiosity/MOBILE/mobile_3.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 720) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  const [modal, setModal] = useState(false)
  const [numberImage, setNumberImage] = useState(1)

  const toggle = () => {
    setModal(!modal)
  }

  const showBigImage = (number) => {
    setNumberImage(number)
    setModal(!modal)
  }

  return (
    <CuriosityWrapper id="curiosity">
      <CuriosityContainer>
        <Row>
          <CuriosityTitleWrapper xs={12}>
            <CuriosityTitle>
              <span>Ciekawostki</span>
            </CuriosityTitle>
          </CuriosityTitleWrapper>
        </Row>
        <Row>
          <CuriosityDescWrapper>
            <p>
              <strong>Wszyscy wiedzą, że{'\u00A0'}dzieci lubią pytać.</strong>
            </p>
            <p>
              Ale nie wszyscy wiedzą, że{'\u00A0'}dorośli też nie wszystko
              wiedzą. Dlatego w{'\u00A0'}tym miejscu szukaj nieoczywistych
              <br /> informacji, które pomogą Ci{'\u00A0'}zaciekawić dziecko
              albo podrzucić mu{'\u00A0'}nieznaną lekturę.
            </p>
          </CuriosityDescWrapper>
        </Row>
        <PocketMoneyBenefit onlyCarousel />
        <Row>
          <CuriosityCardWrapper xs={12} md={4}>
            <div>
              <Img
                fluid={data.CuriosityImage1.childImageSharp.fluid}
                className="curiosityImage"
              />
              <Img
                fluid={data.CuriosityImageMobile1.childImageSharp.fluid}
                className="curiosityImageMobile"
              />
            </div>
            <CuriosityLinkWrapper>
              <CuriosityLink onClick={() => showBigImage(1)}>
                POWIĘKSZ
              </CuriosityLink>
            </CuriosityLinkWrapper>
          </CuriosityCardWrapper>
          <CuriosityCardWrapper xs={12} md={4}>
            <div>
              <Img
                fluid={data.CuriosityImage2.childImageSharp.fluid}
                className="curiosityImage"
              />
              <Img
                fluid={data.CuriosityImageMobile2.childImageSharp.fluid}
                className="curiosityImageMobile"
              />
            </div>
            <CuriosityLinkWrapper>
              <CuriosityLink onClick={() => showBigImage(2)}>
                POWIĘKSZ
              </CuriosityLink>
            </CuriosityLinkWrapper>
          </CuriosityCardWrapper>
          <CuriosityCardWrapper xs={12} md={4}>
            <div>
              <Img
                fluid={data.CuriosityImage3.childImageSharp.fluid}
                className="curiosityImage"
              />
              <Img
                fluid={data.CuriosityImageMobile3.childImageSharp.fluid}
                className="curiosityImageMobile"
              />
            </div>
            <CuriosityLinkWrapper>
              <CuriosityLink onClick={() => showBigImage(3)}>
                POWIĘKSZ
              </CuriosityLink>
            </CuriosityLinkWrapper>
          </CuriosityCardWrapper>
        </Row>
      </CuriosityContainer>
      <CuriosityModal isOpen={modal} size="lg" toggle={toggle}>
        <ModalBody>
          <CuriosityCloseButton onClick={toggle} />
          <div />
          <Img
            fluid={
              data[`CuriosityBigImage${numberImage}`].childImageSharp.fluid
            }
            className="curiosityImage"
          />
          <Img
            fluid={
              data[`CuriosityBigImageMobile${numberImage}`].childImageSharp
                .fluid
            }
            className="curiosityImageMobile"
          />
        </ModalBody>
      </CuriosityModal>
    </CuriosityWrapper>
  )
}

export default Curiosity
